module.exports = __webpack_public_path__ + "static/media/small.4c395437.svg";